export const DATA = {
  list: [
    {
      name: "Green Stone",
      position:
        "Currently hiring for intern, entry + mid-level visual and graphic designers",
      href: "https://www.greenstone.co/",
    },
    {
      name: "Invoke Digital",
      position:
        "Currently hiring for intern UX designer positions. Sept to Dec 2023",
      href: "https://invokedigital.co/",
    },
    {
      name: "Engine Digital",
      href: "https://enginedigital.com/",
    },
    {
      name: "All Purpose",
      href: "https://www.allpurpose.io/",
    },
    {
      name: "Railyard Lab",
      position: "Hiring 3-4 design interns. May 2023 to Aug 2023",
      href: "https://railyardlab.com/",
    },
    {
      name: "Telus Digital",
      position: "Currently hiring for intern UX/product design positions",
      href: "https://www.telus.com/en/digital",
    },
    {
      name: "SAP",
      position:
        "Currently hiring for intern UX designer positions. May 2023 to Sept 2023",
      href: "https://jobs.sap.com/job/Vancouver-SAP-iXp-Intern-UX-Design-Brit-V6B-1A9/893620101/",
    },
    {
      name: "Dijgtal",
      href: "https://dijgtal.com/",
    },
  ],
  speakers: [
    {
      checkpoint: "Doors open",
      time: "9:30",
    },
    {
      checkpoint: "Opening remarks",
      time: "10:00",
    },
    {
      name: "Andrew Fung",
      company: "Evisort",
      designation: "live",
      time: "10:25",
      img: "\\Speakers\\andrew_fung.jpg",
      mobimg: "\\Speakers\\mobile\\Andrew_fung.jpg",
    },
    {
      name: "Ronna Chisholm",
      company: "Railyard Lab",
      designation: "live",
      time: "10:50",
      img: "\\Speakers\\Ronna_Chisholm.png",
      mobimg: "\\Speakers\\mobile\\Ronna_Chisholm.png",
    },
    {
      name: "Sebastiano Boni*",
      company: "Huawei",
      location: "Milan",
      designation: "remote",
      time: "11:10",
      footnote: "*Head of UX at Huawei’s Aesthetic Research Center in Milan",
      img: "\\Speakers\\Sebastiano_Boni.jpg",
      mobimg: "\\Speakers\\mobile\\Sebastiano_Boni.png",
    },
    {
      name: "Andrew Nip",
      company: "Frog",
      location: "London",
      designation: "remote",
      time: "12:00",
      img: "\\Speakers\\Andrew_Nip.jpg",
      mobimg: "\\Speakers\\mobile\\Andrew_Nip.png",
    },
    {
      checkpoint: "Intermission",
      time: "12:30 to 1:15",
    },
    {
      name: "Samantha Slinn",
      company: "MetaLab",
      designation: "live",
      time: "1:20",
      img: "\\Speakers\\Samantha_Slinn.jpg",
      mobimg: "\\Speakers\\mobile\\Samantha_Slinn.png",
    },
    {
      name: "Esther Park",
      company: "Sweetgreen",
      location: "Los Angeles",
      designation: "remote",
      time: "1:45",
      img: "\\Speakers\\Esther_Park.jpg",
      mobimg: "\\Speakers\\mobile\\Esther_Park.png",
    },
    {
      name: "Josh Chisholm",
      company: "Reddit",
      designation: "live",
      time: "2:15",
      img: "\\Speakers\\Josh_Chisholm.png",
      mobimg: "\\Speakers\\mobile\\Josh_Chisholm.png",
    },
    {
      name: "Dominic Wong",
      company: "Invoke Digital",
      designation: "live",
      time: "2:45",
      img: "\\Speakers\\Dominic_Wong.jpg",
      mobimg: "\\Speakers\\mobile\\Dominic_Wong.png",
    },

    {
      checkpoint: "Closing remarks",
      time: "3:15",
    },
  ],
};
